class MCLoadMore {
  constructor() {
    this.onClick = this.onClick.bind(this);
    document.addEventListener('click', this.onClick);
  }

  async onClick(event) {
    const link = event.target.closest('[data-mc-load-more]');
    if (!link || link.classList.contains('is-loading')) return;

    event.preventDefault();
    const target = document.querySelector(link.dataset.target);
    if (!target) {
      window.location.assign(link.href);
      return;
    }

    const originalLabel = link.textContent;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    link.textContent = link.dataset.loadingLabel || 'Chargement…';

    try {
      const response = await fetch(link.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextTarget = nextDocument.querySelector(link.dataset.target);
      if (!nextTarget) throw new Error('Contenu suivant introuvable');

      const itemSelector = link.dataset.item;
      nextTarget.querySelectorAll(`:scope > ${itemSelector}`).forEach((item) => {
        item.classList.add('scroll-trigger--cancel');
        target.appendChild(document.importNode(item, true));
      });

      const nextLink = nextDocument.querySelector('[data-mc-load-more]');
      if (nextLink) {
        link.href = nextLink.href;
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
        link.textContent = originalLabel;
      } else {
        link.closest('.mc-load-more')?.remove();
      }

      document.dispatchEvent(new CustomEvent('mc:content-appended', { detail: { target } }));
    } catch (error) {
      link.classList.remove('is-loading');
      link.removeAttribute('aria-busy');
      link.textContent = originalLabel;
      window.location.assign(link.href);
    }
  }
}

new MCLoadMore();
